import React from 'react';

function StatCard({ label, value, variant = 'secondary', subtitle }) {
    const colorMap = {
        secondary: '#6c757d',
        success: '#198754',
        primary: '#0d6efd',
        info: '#0dcaf0',
        warning: '#ffc107',
        danger: '#dc3545',
        purple: '#7c3aed',
    };
    const color = colorMap[variant] || colorMap.secondary;
    return (
        <div className="card h-100">
            <div className="card-body text-center py-3">
                <div className="h3 mb-1 fw-bold" style={{ color }}>
                    {value ?? '—'}
                </div>
                <div className="small fw-semibold text-muted">{label}</div>
                {subtitle && <div className="text-muted" style={{ fontSize: '0.7rem' }}>{subtitle}</div>}
            </div>
        </div>
    );
}

export default function CampaignAnalyticsCards({ analytics }) {
    if (!analytics) return null;

    const {
        recipient_total = 0,
        recipient_sent = 0,
        recipient_delivered = 0,
        recipient_opened = 0,
        recipient_clicked = 0,
        recipient_bounced = 0,
        recipient_complained = 0,
        recipient_failed = 0,
        recipient_unsubscribed = 0,
    } = analytics;

    const pct = (n) => recipient_sent > 0 ? ` (${Math.round((n / recipient_sent) * 100)}%)` : '';

    return (
        <div className="row g-3">
            <div className="col-6 col-md-4 col-lg-3">
                <StatCard label="Total recipients" value={recipient_total} variant="secondary" />
            </div>
            <div className="col-6 col-md-4 col-lg-3">
                <StatCard label="Sent" value={recipient_sent} variant="primary" />
            </div>
            <div className="col-6 col-md-4 col-lg-3">
                <StatCard label="Delivered" value={recipient_delivered} variant="success"
                    subtitle={pct(recipient_delivered)} />
            </div>
            <div className="col-6 col-md-4 col-lg-3">
                <StatCard label="Opened" value={recipient_opened} variant="info"
                    subtitle={pct(recipient_opened)} />
            </div>
            <div className="col-6 col-md-4 col-lg-3">
                <StatCard label="Clicked" value={recipient_clicked} variant="purple"
                    subtitle={pct(recipient_clicked)} />
            </div>
            <div className="col-6 col-md-4 col-lg-3">
                <StatCard label="Bounced" value={recipient_bounced} variant={recipient_bounced > 0 ? 'warning' : 'secondary'} />
            </div>
            <div className="col-6 col-md-4 col-lg-3">
                <StatCard label="Complained" value={recipient_complained} variant={recipient_complained > 0 ? 'danger' : 'secondary'} />
            </div>
            <div className="col-6 col-md-4 col-lg-3">
                <StatCard label="Failed / Unsub" value={`${recipient_failed} / ${recipient_unsubscribed}`} variant="secondary" />
            </div>
        </div>
    );
}
